import { isThisMonth } from 'date-fns'
import { POST } from '@/api'
import { toHourClock } from '@/utils/date'
import { setAnnotations, getAnnotationConfigs, toShortLabel } from '@/utils/analysis'

export default {
  namespaced: true,
  state: {
    isCurrentMonth: false,
    currentDay: 0,
    progress: null,
    table: null,
    summary: null,
    busy: false,
  },
  modules: {},
  mutations: {
    set(state, { data, endTerm }) {
      state.progress = data.charts?.progress ?? null
      state.table = data.table
      state.summary = data.summary
      state.currentDay = +toHourClock(new Date()).day
      state.isCurrentMonth = isThisMonth(endTerm)
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  getters: {
    chart({ isCurrentMonth, currentDay, progress }) {
      if (progress === null) {
        return null
      }

      // ラベルを表示用に変換する
      let [columns, ...rows] = progress.map(([term, ...rest], idx) => [
        idx === 0 ? term : toShortLabel(term, 2),
        ...rest,
      ])

      // 注訳を追加
      const { definitions, values } = getAnnotationConfigs('point')
      const lastPerformanceIndex = currentDay - 1

      // columns
      columns = setAnnotations(columns, ...definitions)
      const [unitName, ...seriesNames] = columns
      columns = [unitName, { type: 'string', role: 'annotation' }, ...seriesNames].filter(v => v !== null)

      // rows
      rows = rows.map(row => setAnnotations(row, ...values).filter(v => v !== null))
      if (isCurrentMonth) {
        rows[lastPerformanceIndex][2] = 'point { size: 4; stroke-color: #fff; stroke-width: 1; }'
      }
      rows = rows.map((row, index) => {
        const [hAxisName, ...seriesValue] = row
        return [hAxisName, index === lastPerformanceIndex && isCurrentMonth ? '' : null, ...seriesValue]
      })

      return [columns, ...rows]
    },
    header({ table }) {
      return table?.header ?? null
    },
    data({ table }) {
      return table?.value ?? []
    },
  },
  actions: {
    async get(store, { endTerm }) {
      const { commit, state } = store
      if (state.busy) return

      commit('busy', true)

      const { status, message, data } = await POST('/api/web/analysis/progress', { endTerm })

      if (status === 200) {
        commit('set', { data, endTerm })
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
    },
  },
}
